// extracted by mini-css-extract-plugin
export default {"select":"Select_select__TFbno","trigger":"Select_trigger__uYUaF","list":"Select_list__f1f9H","option":"Select_option__ZOZeB","optionSelected":"Select_optionSelected__ERceZ"};